import { render, staticRenderFns } from "./InternalNotes.vue?vue&type=template&id=f40237fe&scoped=true"
import script from "./InternalNotes.vue?vue&type=script&lang=js"
export * from "./InternalNotes.vue?vue&type=script&lang=js"
import style0 from "./InternalNotes.vue?vue&type=style&index=0&id=f40237fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40237fe",
  null
  
)

export default component.exports